import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form'
import { Grid, Row, Col } from 'react-bootstrap';
import Select from "../common/form/elements/select";
import SiteLoader from '../layout/site-loader';
import { getStockItIncentivesOutletVisitData } from '../../actions/stock-it-incentives';
import IgniteDataTable from '../common/datatable';
import { dateFormat } from '../../utils/commonFunctions';
import { Cancel, Tick } from '../common/icons';

import './style.css';

class StockItResults extends Component {
  constructor(props) {
    super(props);

    const { match } = props;
    this.id = +match.params.id;
    this.state = {
      selectedValue: ''
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(actions.reset('deep.stock_it_incentives_outlet_visit_data.visit_date'));
    dispatch(getStockItIncentivesOutletVisitData(this.id));
  }

  renderSkuCell = (sku, name, image) => {
    return (
      <div>
        <img src={image} className={"sku-picture"} /> {sku} {name}
      </div>
    );
  };

  renderStockStatusCell = (podriaStatus) => {
    return (
      podriaStatus === 'P' || podriaStatus === 'I' ? <div className="result-container result-container-green">
        <Tick height={12} width={12} fill="white"/>
      </div> :
      <div className="result-container result-container-red">
        <Cancel height={12} width={12} fill="white"/>
      </div>
    );
  };

  handleOnChange = (value) => {
    this.setState({ selectedValue: value });
  };

  tableData = (products) => {
    const { selectedValue } = this.state;

    if (selectedValue === '') {
      return [];
    }

    return products
            .filter((product) => product['visit-date'] === selectedValue)
            .map((product, index) => ({
              id: index + 1,
              visitDate: dateFormat(product['visit-date']),
              sku: this.renderSkuCell(product.sku, product.name, product.image),
              podriaStatus: this.renderStockStatusCell(product['podria-status'])
            }));
  };

  render() {
    const { fetching, fetched, stockItIncentivesOutletVisitData } = this.props;
    const { selectedValue } = this.state;
    const isLoading = (fetching || !fetched) || Object.keys(stockItIncentivesOutletVisitData).length === 0;

    if (isLoading) {
      return <SiteLoader />;
    }

    const columns = [
      { prop: 'id', title: '',  width: '75' },
      { prop: 'visitDate', title: 'Visit Date', width: '200' },
      { prop: 'sku', title: 'SKU' },
      { prop: 'podriaStatus', title: 'In stock', width: '75' }
    ];

    const visitDates = stockItIncentivesOutletVisitData.attributes['visit-dates'].map(
      (visitDate) => ({ value: visitDate['visit-date'], label: `Visit date: ${dateFormat(visitDate['visit-date'])}` })
    );

    const data = this.tableData(stockItIncentivesOutletVisitData.attributes['products']);

    return (
      <Grid bsClass="container">
        <Row>
          <h1>Store performance</h1>
        </Row>
        <Row>
          <h2>Stock it incentive</h2>
        </Row>
        <Row>
          <Col lg={4}>
            Filter by:
            {!isLoading && <Select
              onChange={this.handleOnChange}
              model='deep.stock_it_incentives_outlet_visit_data.visit_date'
              values={visitDates}
              value={selectedValue}
            />}
          </Col>
        </Row>
        <Row>
          <IgniteDataTable
            columns={columns}
            data={data || []}
            hasAttributes={false}
          />
        </Row>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    fetching: state.stockItIncentives.fetching,
    fetched: state.stockItIncentives.fetched,
    stockItIncentivesOutletVisitData: state.stockItIncentives.stock_it_incentives_outlet_visit_data,
  };
}

export default connect(mapStateToProps)(StockItResults);



// WEBPACK FOOTER //
// ./src/components/stock-it-results/index.jsx